export const createIdFromContent = (content: string): string => {
  if (!content || typeof content !== 'string') {
    return '';
  }

  return content
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s]/gi, '')
    .replaceAll(' ', '-');
};
